export default "__VITE_ASSET__CrZWhl39__"